import { getAccommodationData } from 'actions/accommodation';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel.js';

export default store => ({
	path: 'rooms',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'Accommodation',
			),
		onEnter: ({ params: { lang, hotel } }) => {
			store.dispatch(getAccommodationData(lang, hotel));
			store.dispatch(getBanner(lang, hotel, 'accommodation'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'rooms'));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Accommodation/index.js